export const useCaptureOAuthTokenResponses: Record<string, number> = {
  success: 201,
  failure: 500,
  f7fbbb5d2e02483eb61ea1ba8dab81a8_c2V0bC10ZXN0: 201
}
